<!--
   Created by qing on 2022/7/15 下午7:40
   Des:
-->
<template>
    <div class="app-error-page">
        <div class="content">
            <div class="icon">
                <svg t="1657761747769" class="icon" viewBox="0 0 1024 1024" version="1.1"
                     xmlns="http://www.w3.org/2000/svg" p-id="10473" width="200" height="200">
                    <path d="M512 512m-460.8 0a460.8 460.8 0 1 0 921.6 0 460.8 460.8 0 1 0-921.6 0Z" fill="#FFE5E3"
                          p-id="10474"></path>
                    <path
                            d="M606.72 432.64c10.24 17.92 3.84 42.24-14.08 52.48l-78.08 44.8c-17.92 10.24-42.24 3.84-52.48-14.08-10.24-17.92-3.84-42.24 14.08-52.48l78.08-44.8c19.2-10.24 42.24-3.84 52.48 14.08z"
                            fill="#FC796F" p-id="10475"></path>
                    <path
                            d="M515.84 476.16c16.64 14.08 17.92 38.4 5.12 53.76l-65.28 78.08c-14.08 16.64-38.4 17.92-53.76 5.12-16.64-14.08-17.92-38.4-5.12-53.76l65.28-78.08c12.8-16.64 37.12-19.2 53.76-5.12z"
                            fill="#FC796F" p-id="10476"></path>
                    <path
                            d="M678.4 230.4c14.08 0 25.6 11.52 25.6 25.6v281.6c0 14.08-11.52 25.6-25.6 25.6s-25.6-11.52-25.6-25.6V256c0-14.08 11.52-25.6 25.6-25.6z"
                            fill="#FC4F42" p-id="10477"></path>
                    <path
                            d="M560.64 279.04c10.24-10.24 25.6-10.24 35.84 0l199.68 199.68c10.24 10.24 10.24 25.6 0 35.84-10.24 10.24-25.6 10.24-35.84 0L560.64 314.88c-10.24-8.96-10.24-25.6 0-35.84z"
                            fill="#FC4F42" p-id="10478"></path>
                    <path
                            d="M796.16 279.04c10.24 10.24 10.24 25.6 0 35.84L596.48 514.56c-10.24 10.24-25.6 10.24-35.84 0-10.24-10.24-10.24-25.6 0-35.84l199.68-199.68c8.96-10.24 25.6-10.24 35.84 0z"
                            fill="#FC4F42" p-id="10479"></path>
                    <path
                            d="M844.8 396.8c0 14.08-11.52 25.6-25.6 25.6H537.6c-14.08 0-25.6-11.52-25.6-25.6s11.52-25.6 25.6-25.6h281.6c14.08 0 25.6 11.52 25.6 25.6z"
                            fill="#FC4F42" p-id="10480"></path>
                    <path
                            d="M596.860617 478.241112a115.2 115.2 0 1 0 162.914559-162.920246 115.2 115.2 0 1 0-162.914559 162.920246Z"
                            fill="#FCBBB6" p-id="10481"></path>
                    <path
                            d="M678.4 537.6c-37.12 0-72.96-14.08-99.84-40.96-32-32-47.36-76.8-39.68-122.88 8.96-58.88 56.32-106.24 115.2-115.2 46.08-7.68 90.88 6.4 122.88 39.68 32 32 47.36 76.8 39.68 122.88-8.96 58.88-56.32 106.24-115.2 115.2-7.68 1.28-15.36 1.28-23.04 1.28z m0-230.4c-5.12 0-10.24 0-15.36 1.28-37.12 6.4-66.56 35.84-72.96 72.96-5.12 29.44 3.84 57.6 25.6 79.36s49.92 29.44 78.08 25.6c37.12-6.4 66.56-35.84 72.96-72.96 5.12-29.44-3.84-57.6-25.6-79.36-16.64-17.92-38.4-26.88-62.72-26.88z"
                            fill="#FC796F" p-id="10482"></path>
                    <path
                            d="M358.4 384h64c21.76 0 38.4 16.64 38.4 38.4v204.8c0 21.76-16.64 38.4-38.4 38.4H192c-7.68 0-12.8-5.12-12.8-12.8V418.56c3.84 2.56 7.68 3.84 12.8 3.84h140.8c14.08 0 25.6-11.52 25.6-25.6v-12.8z"
                            fill="#FC4F42" p-id="10483"></path>
                    <path
                            d="M384 652.8H243.2l39.68 76.8H384zM577.28 592.64l5.12-10.24c3.84-7.68 11.52-15.36 20.48-15.36 8.96-1.28 16.64 2.56 21.76 8.96l140.8 161.28c10.24 11.52 16.64 25.6 17.92 39.68 2.56 20.48-3.84 30.72-12.8 37.12l-1.28 1.28c-15.36 12.8-38.4 14.08-55.04 2.56-3.84-2.56-7.68-6.4-10.24-10.24l-122.88-168.96c-8.96-14.08-10.24-30.72-3.84-46.08z"
                            fill="#FC4F42" p-id="10484"></path>
                    <path
                            d="M490.24 509.44l34.56 52.48 48.64-39.68-42.24-44.8c16.64-6.4 34.56-7.68 53.76-1.28 32 10.24 55.04 38.4 57.6 71.68 3.84 52.48-37.12 93.44-87.04 90.88-47.36-2.56-84.48-44.8-79.36-90.88 2.56-15.36 6.4-28.16 14.08-38.4z"
                            fill="#FC4F42" p-id="10485"></path>
                </svg>
            </div>
            <h3>您的账号已被停用</h3>
            <h3>如有问题，请联系管理员</h3>
            <button @click="onClickBackHome" v-if="isShowCheck">切换团队</button>
        </div>
        <van-action-sheet
                v-model="showCompanyList"
                :actions="actions"
                cancel-text="取消"
                close-on-click-action
                @select="onSelectCompany"
        />
    </div>
</template>

<script>
    export default {
        name: "app_error",
        data() {
            return {
                showCompanyList: false,
                companyList: [],
            }
        },
        methods: {
            onClickBackHome() {

                this.$store.dispatch('actionCompanyList', {
                    userId: this.$store.getters.userId
                }).then(res => {
                    this.companyList = res
                }).catch(console.error)

                this.showCompanyList = true
            },
            onSelectCompany(item) {
                this.currentCompany = item
                this.$store.commit('UPDATE__COMPANY', item)
                this.$store.commit('UPDATE__COMPANY_ID', item.companyId)
                this.$toast(`已切换到「${item.companyName}」`)

                if (!this.$store.getters.env || this.$store.getters.env === 'smallProgram') {
                    this.$wx.miniProgram.navigateTo('/apply/index')
                } else {
                    this.$router.push('/home/apps')
                }
            }
        },
        computed: {
            actions() {
                const arr = []
                this.companyList.forEach(item => {
                    arr.push({
                        name: item.companyName,
                        ...item,
                        disabled: item.accountDisable === 'YES'
                    })
                })
                return arr
            },
            isShowCheck() {
                return !(window.isWxWork || window.isLark || window.isDingtalk)
            }
        }
    }
</script>

<style lang="less">

    .app-error-page {
        height: 100%;

        .content {
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            background: #ffffff;
            padding: 20px;


            .icon {
                width: 140px;
                height: 140px;
            }

            h3 {
                color: #333333;
                margin: 20px;
            }

            .user-desc {
                color: #666666;
                margin: 20px;
                line-height: 24px;

                span {
                    color: #333333;
                }
            }

            .desc {
                color: #333333;
                margin: 20px;
                line-height: 24px;
            }

            button {
                padding: 0 12px;
                height: 32px;
                font-size: 16px;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #ffffff;
                background: #1b9aee;
                border: none;
                border-radius: 4px;
                cursor: pointer;

                &:hover {
                    opacity: 0.5;
                }
            }
        }
    }

</style>